document.addEventListener("click", function (e) {

  const swatch = e.target.closest(".rtw-wedding-product-option-data");
  if (!swatch) return;

  const card = swatch.closest(".tps-wedding-card");
  if (!card) return;

  const handle = card.dataset.handle;
 
  const selectedMetal = swatch.dataset.value?.trim();    
  if (!handle || !selectedMetal) return;

  // Cache product data (prevents multiple fetch calls)
  if (!card._productDataPromise) {
    card._productDataPromise = fetch(`/products/${handle}.js`)
      .then(res => res.json())
      .catch(err => {
        console.log("Product fetch error:", err);
        return null;
      });
  }

  card._productDataPromise.then(product => {

    if (!product || !product.variants) return;      

    // =========================
    // FIND WHICH OPTION IS METAL
    // =========================
    const metalOptionIndex = product.options.findIndex(opt =>
      opt.name &&
      opt.name.toLowerCase().includes("metal")
    );

    if (metalOptionIndex === -1) {
      console.log("Metal option not found in product options");
      return;
    }

    // option index in variants is 1-based
    const optionKey = "option" + (metalOptionIndex + 1);

    // =========================
    // FIND MATCHING VARIANT
    // =========================
    const variant = product.variants.find(v =>
      v[optionKey] &&
      v[optionKey].trim().toLowerCase() === selectedMetal.toLowerCase()
    );

    if (!variant) {
      console.log("No variant found for:", selectedMetal);
      return;
    }

    // =========================
    // UPDATE IMAGE (DAWN SAFE)
    // =========================
    const wrapper = card.closest(".card-wrapper");
    const defaultImg = wrapper?.querySelector("img.default_image");
    const hoverImg = wrapper?.querySelector("img.hover-img");

    if (variant.featured_image?.src) {

      const baseSrc = variant.featured_image.src;
      const cleanSrc = baseSrc.includes("?") ? baseSrc : baseSrc + "?v=1";

      const newSrc = cleanSrc + "&width=600";

      const newSrcset = `
        ${cleanSrc}&width=165 165w,
        ${cleanSrc}&width=360 360w,
        ${cleanSrc}&width=533 533w,
        ${cleanSrc}&width=720 720w,
        ${cleanSrc}&width=940 940w,
        ${cleanSrc} 1000w
      `;

       const newAlt = `${product.title} - ${selectedMetal}`;
      if (defaultImg) {
        defaultImg.src = newSrc;
        defaultImg.srcset = newSrcset;
         defaultImg.alt = newAlt;
         defaultImg.title = newAlt;
      }

      if (hoverImg) {
        hoverImg.src = newSrc;
        hoverImg.srcset = newSrcset;
        hoverImg.alt = newAlt;
        hoverImg.title = newAlt;
      }
    }

    // =========================
    // UPDATE PRICE
    // =========================
    const priceWrapper = wrapper?.querySelector(".price");

    // if (priceWrapper && typeof Shopify !== "undefined") {
    //   priceWrapper.innerHTML = Shopify.formatMoney(variant.price);
    // }
    if (priceWrapper && typeof Shopify !== "undefined") {

      let moneyFormat = window.Shopify?.currency?.active
        ? Shopify.money_format
        : document.querySelector('[data-money-format]')?.dataset.moneyFormat;

      if (!moneyFormat) {
        moneyFormat = "{{ shop.money_format }}";
      }

      priceWrapper.innerHTML = Shopify.formatMoney(variant.price, moneyFormat);
    }

    // =========================
    // UPDATE VARIANT ID
    // =========================
    const variantInput = wrapper?.querySelector(".product-variant-id");

    if (variantInput) {
      variantInput.value = variant.id;
    }

    // =========================
    // UPDATE SELECTED LABEL
    // =========================
    const label = wrapper?.querySelector(".selected_class_label");

    if (label) {
      label.innerText = selectedMetal;
    }

    // =========================
    // ACTIVE CLASS SWITCH
    // =========================
    card.querySelectorAll(".rtw-product-option-data")
      .forEach(el => el.classList.remove("active"));

    swatch.classList.add("active");

  });

});


jQuery(document).on('mouseenter mouseleave','.rtw-product-option-data',function (e) {
    var $this = jQuery(this);
    var productId = $this.closest('.metal-variants').data('product-id');
    var $labelContainer = jQuery('.listing_swatch[data-product-id="' + productId + '"]' ).next('.tps_product-variant-label');

    var textToShow;

    if (e.type === 'mouseenter') {
      // On Hover
      textToShow = $this.attr('title');
    } else {
      // On Leave → revert to active
      textToShow = $this
        .closest('.product-swatches')
        .find('.rtw-product-option-data.active')
        .attr('title');
    }

    $labelContainer.find('.selected_class_label').text(textToShow);
  }
);